<template>
    <div>
        <v-layout row wrap justify-center>
              <v-flex xs12 sm7 md7 >
                  <dialogos-app :dialogos="dialogosRegion" tucan="0"></dialogos-app>
              </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center mt-4>
            <v-flex xs12 sm7 md7 class="cont-img">
                <video :src="url" buffered controls 
                       :width="widthVideo" 
                       controlslist="nodownload"
                       @ended="$store.commit('nextShow',true)" 
                ></video>
            </v-flex>
        </v-layout>        
    </div>
</template>

<script>
export default {
    data(){
        return {
            dialogosRegion:[
                'A região Sul tem 3 estados: Paraná, Rio Grande do Sul e Santa Catarina.',
                'Porto Alegre é uma das cidades mais visitadas da região. Clique no vídeo para conhecê-la.',
            ],
            widthVideo:'100%',
            url:  'videos/ibraco-presentacion-4.mp4',
        }
    }
}
</script>